// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3MSWB","buttons":"Footer_buttons__JdUef"};